import { z } from 'zod';

export const OneOnOneNotes = z.object({
  notesId: z.number().nullable(),
  instanceDataId: z.number().nullable(),
  instanceId: z.number().nullable(),
  feedbackText: z.string().nullable(),
  feedbackTextHtml: z.string().nullable(),
  employeeId: z.number().nullable(),
  isPrivate: z.boolean(),
});
